import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { HeaderComponent } from '../../header/header.component';
import { FooterComponent } from '../../footer/footer.component';
import { ActivatedRoute } from '@angular/router';
import { CruscottoRichiestaService } from '../cruscotto-richiesta.service';
import { Allegato, Richiesta } from '../../types/Richiesta';
import { Operatore } from '../../types/Operatore';
import { Paziente } from '../../types/Paziente';
import { Richiedente } from '../../types/Richiedente';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { PopupDettaglioComponent } from './popup-dettaglio/popup-dettaglio.component';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { NgFor, NgIf } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { StepperDettaglioComponent } from "./stepper-dettaglio/stepper-dettaglio.component";
import { DettaglioRichiestaService } from './dettaglio-richiesta.service';
import { catchError, concatMap } from 'rxjs';
import { GestioneRichiestaComponent } from "./gestione-richiesta/gestione-richiesta.component";
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { SessioneUvmComponent } from "./../../richiesta-utils/sessione-uvm/sessione-uvm.component";
import { EsitoUvmComponent } from "./../../richiesta-utils/esito-uvm/esito-uvm.component";
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SicotService } from '../../sicot.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SafeResourceUrl } from '@angular/platform-browser';
import { DialogDocumentViewerComponent } from '../../dialog-document-viewer/dialog-document-viewer.component';
@Component({
  selector: 'app-dettaglio-richiesta',
  standalone: true,
  imports: [MatProgressSpinnerModule, EsitoUvmComponent, SessioneUvmComponent, MatTabsModule, HeaderComponent, FooterComponent, MatCardModule, MatButtonModule, MatDialogModule, MatListModule, MatIconModule, NgIf, MatTableModule, MatPaginatorModule, CommonModule, MatProgressBarModule, GestioneRichiestaComponent],
  templateUrl: './dettaglio-richiesta.component.html',
  styleUrl: './dettaglio-richiesta.component.css'
})
export class DettaglioRichiestaComponent {

  interventoIniziale: MatTableDataSource<any>;
  showSessioneUVM: boolean = false;
  showEsitoUVM: boolean = false;
  showPDE: boolean = false;
  displayedColumnsInterventoPaziente: string[] = [
    'tipoIntervento',
    'tipoOperatore',
    'operatore',
    'strutturaRiferimento',
    'frequenza',
    'attivita'
  ];

  caricamento = true;

  readonly dialog = inject(MatDialog);

  openDialog(obj: any) {
    const dialogRef = this.dialog.open(PopupDettaglioComponent, {
      data: {
        obj
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  /** Testo qualifiche operatore (da referente_operatore_ruolo), per card Operatore inviante. */
  getQualificheText(op: Operatore | undefined): string {
    if (!op?.qualifiche?.length) return 'Nessuna qualifica';
    return op.qualifiche.map(q => q.descrizione).filter(Boolean).join(', ');
  }

  dataSourceAllegati: any;
  idRichiesta: number | undefined;
  richiesta: any;
  operatore: Operatore | undefined;
  paziente: Paziente | undefined;
  richiedente: Richiedente | undefined;
  displayedColumns: string[] = ['icon', 'tipo', 'contenuto', 'descrizione'];
  generazioneAllegatoInCorso = false;
  downloadAllegatoInCorso = {
    state: false,
    id: -1
  }


  constructor(private siCotService: SicotService, private http: HttpClient, private activatedRoute: ActivatedRoute, private cruscottoRichiestaService: CruscottoRichiestaService, private dettaglioRichiestaService: DettaglioRichiestaService) {
    this.interventoIniziale = new MatTableDataSource<any>();
  }

  ngOnInit() {

    this.getRichiesta();

  }

  getRichiesta() {

    let id = this.activatedRoute.snapshot.paramMap.get('id');
    if (id) {
      this.idRichiesta = parseInt(id);
    } else {
      return;
    }

    this.cruscottoRichiestaService.getRichiesta(this.idRichiesta)
      .subscribe((richiesta: Richiesta) => {



        this.richiesta = richiesta;
        if (richiesta.allegati) {
          this.dataSourceAllegati = new MatTableDataSource<Allegato>(richiesta.allegati);
        }

        if (richiesta.operatoreInvianteId) {
          this.cruscottoRichiestaService.getOperatore(richiesta.operatoreInvianteId)
            .subscribe((operatore: Operatore) => {
              this.operatore = operatore;

            })
        }

        if (richiesta.pazienteId) {
          this.cruscottoRichiestaService.getPaziente(richiesta.pazienteId)
            .subscribe((paziente: Paziente) => {
              this.paziente = paziente;
              console.log(richiesta.pazienteId)
              console.log(paziente.codiceFiscale)
            })
        }

        if (richiesta.richiedenteId) {
          this.cruscottoRichiestaService.getRichiedente(richiesta.richiedenteId)
            .subscribe((richiedente: Richiedente) => {
              this.richiedente = richiedente;

            })
        }

        this.caricamento = false;

      })

    this.refreshState({});

  }




  refreshState(event: any): void {
    const setEsitoTab = (r: Richiesta | undefined) => {
      this.showEsitoUVM = (r?.stato?.toLowerCase() === 'valutata da uvm');
    };
    if (event && this.idRichiesta != null) {
      this.cruscottoRichiestaService.getRichiesta(this.idRichiesta).subscribe({
        next: (r: Richiesta) => {
          this.richiesta = r;
          if (r.allegati) {
            this.dataSourceAllegati = new MatTableDataSource<Allegato>(r.allegati);
          }
          setEsitoTab(r);
        }
      });
    } else {
      setEsitoTab(this.richiesta);
    }

    this.siCotService.getSessioneUvm(this.idRichiesta).subscribe({
      next: (data) => {
        this.showSessioneUVM = true;
      },
      error: (err) => {
        this.showSessioneUVM = false;
      }
    });

    this.getInterventoPaziente();
  }


  scarica(allegato: Allegato) {

    return new Promise<void>((resolve, reject) => {

      this.downloadAllegatoInCorso.state = true;
      this.downloadAllegatoInCorso.id = allegato?.id || -1;

      let allegatoId = allegato.id;
      if (!allegatoId) return;

      this.dettaglioRichiestaService.getAllegato(allegatoId).subscribe((res: Allegato) => {
        this.dettaglioRichiestaService.downloadFile(allegatoId).subscribe(blob => {
          /*
                    const downloadLink = document.createElement('a');
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = `${res.nome}.${res.tipo?.contentType}`;
                    downloadLink.click();
                    */
          this.openDocumentDialog(URL.createObjectURL(blob), blob?.type);
          //window.open(fileUrl, '_blank');
          this.downloadAllegatoInCorso.state = false;
          resolve();

        }, error => {

          console.error('Error downloading the file', error);
          this.downloadAllegatoInCorso.state = false;
          reject();

        });

      }, error => {

        console.error('Error downloading the file', error);
        this.downloadAllegatoInCorso.state = false;
        reject();

      });

    })

  }

  openDocumentDialog(url: any, documentType: string) {
    this.dialog.open(DialogDocumentViewerComponent, {
      height: "calc(100% - 30px)",
      width: "calc(100% - 30px)",
      maxWidth: "100%",
      maxHeight: "100%",
      data: {
        url: url,
        documentType: documentType
      },
    },
    );
  }

  getDownloadAllegatoInCorso(allegato: Allegato) {
    return this.downloadAllegatoInCorso.state && this.downloadAllegatoInCorso.id === allegato.id;
  }

  generaAllegato(richiesta: Richiesta) {

    this.generazioneAllegatoInCorso = true;

    this.dettaglioRichiestaService.salvaAllegatoReportRichiesta(richiesta)
      .subscribe({
        next: (allegato: Allegato) => {

          this.scarica(allegato)
            .finally(() => {
              this.getRichiesta();
              this.generazioneAllegatoInCorso = false;
            })

        },
        error: (err) => {
          this.generazioneAllegatoInCorso = false;
          console.log(err);
        }
      });

  }

  getInterventoPaziente() {
    this.siCotService.getInterventiPazienteByRichiesta(this.idRichiesta)
      .subscribe({
        next: (response: any[]) => {
          this.showPDE = response.length > 0;
          this.interventoIniziale = new MatTableDataSource<any>(response);
        },
        error: (error: any) => {
          console.error('Errore durante l\'esecuzione delle operazioni:', error);
        }
      });
  }

}
